import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import SmallAccentLineMetricItem, {
  SmallAccentLineMetricItemProps,
} from 'molecules/SmallAccentLineMetricItem/SmallAccentLineMetricItem';

export interface MetricsGridProps {
  items: SmallAccentLineMetricItemProps[];
  totalColumns?: number;
  totalColumnsLg?: number;
  totalColumnsSm?: number;
}

const MetricsGrid = ({
  items,
  totalColumns = 3,
  totalColumnsLg = 2,
  totalColumnsSm = 1,
}: MetricsGridProps): JSX.Element => {
  return (
    <Grid
      totalColumns={totalColumns}
      totalColumnsLg={totalColumnsLg}
      totalColumnsSm={totalColumnsSm}
      gap='spacing-4xl'
    >
      {items.map((item, index) => (
        <SmallAccentLineMetricItem
          key={index}
          {...item}
        />
      ))}
    </Grid>
  );
};

export default MetricsGrid;
